// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quillEditor_quillEditor__rwVQ2 .ql-toolbar {
  border: var(--p-border-width-0165) solid var(--p-color-input-border);
  border-radius: var(--p-border-radius-200) var(--p-border-radius-200) 0 0;
  background: var(--p-color-bg-surface-secondary);
}

.quillEditor_quillEditor__rwVQ2 .ql-toolbar button:hover,
.quillEditor_quillEditor__rwVQ2 .ql-toolbar button.ql-active {
  background-color: var(--p-color-bg-fill-transparent-hover);
}

.quillEditor_quillEditor__rwVQ2 .ql-container {
  border: var(--p-border-width-0165) solid var(--p-color-input-border);
  border-radius: 0 0 var(--p-border-radius-200) var(--p-border-radius-200);
}

.quillEditor_quillEditor__rwVQ2 .ql-snow .ql-picker.ql-header .ql-picker-label:not([data-value])::before, 
.quillEditor_quillEditor__rwVQ2 .ql-snow .ql-picker.ql-header .ql-picker-item:not([data-value])::before {
  content: 'Paragraph';
}

.quillEditor_quillEditor__rwVQ2 .ql-editor{
  min-height:150px;
  font-family: var(--p-font-family-sans);
}

.quillEditor_quillEditor__rwVQ2 .ql-editor p, 
.quillEditor_quillEditor__rwVQ2 .ql-editor ol, 
.quillEditor_quillEditor__rwVQ2 .ql-editor ul, 
.quillEditor_quillEditor__rwVQ2 .ql-editor pre, 
.quillEditor_quillEditor__rwVQ2 .ql-editor blockquote, 
.quillEditor_quillEditor__rwVQ2 .ql-editor h1, 
.quillEditor_quillEditor__rwVQ2 .ql-editor h2, 
.quillEditor_quillEditor__rwVQ2 .ql-editor h3, 
.quillEditor_quillEditor__rwVQ2 .ql-editor h4, 
.quillEditor_quillEditor__rwVQ2 .ql-editor h5, 
.quillEditor_quillEditor__rwVQ2 .ql-editor h6 {
  margin-bottom: 1rem;
}

.quillEditor_quillEditor__rwVQ2 .ql-editor ol, 
.quillEditor_quillEditor__rwVQ2 .ql-editor ul {
  padding-left: 0;
}

.quillEditor_quillEditor__rwVQ2 .ql-editor ul li {
  position: relative;
  list-style: none;
}
  
.quillEditor_quillEditor__rwVQ2 .ql-editor ul li::before {
  content: '\\2714';
  margin-left: -1.4em;
  position: absolute;
  font-family: Arial, sans-serif;
}

.quillEditor_quillEditor__rwVQ2 .ql-editor h1, 
.quillEditor_quillEditor__rwVQ2 .ql-editor h2, 
.quillEditor_quillEditor__rwVQ2 .ql-editor h3, 
.quillEditor_quillEditor__rwVQ2 .ql-editor h4, 
.quillEditor_quillEditor__rwVQ2 .ql-editor h5, 
.quillEditor_quillEditor__rwVQ2 .ql-editor h6 {
  font-weight: bold;
}
`, "",{"version":3,"sources":["webpack://./src/common/quillEditor.module.css"],"names":[],"mappings":"AAAA;EACE,oEAAoE;EACpE,wEAAwE;EACxE,+CAA+C;AACjD;;AAEA;;EAEE,0DAA0D;AAC5D;;AAEA;EACE,oEAAoE;EACpE,wEAAwE;AAC1E;;AAEA;;EAEE,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,sCAAsC;AACxC;;AAEA;;;;;;;;;;;EAWE,mBAAmB;AACrB;;AAEA;;EAEE,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;;;;;;EAME,iBAAiB;AACnB","sourcesContent":[".quillEditor :global(.ql-toolbar) {\n  border: var(--p-border-width-0165) solid var(--p-color-input-border);\n  border-radius: var(--p-border-radius-200) var(--p-border-radius-200) 0 0;\n  background: var(--p-color-bg-surface-secondary);\n}\n\n.quillEditor :global(.ql-toolbar button:hover),\n.quillEditor :global(.ql-toolbar button.ql-active) {\n  background-color: var(--p-color-bg-fill-transparent-hover);\n}\n\n.quillEditor :global(.ql-container) {\n  border: var(--p-border-width-0165) solid var(--p-color-input-border);\n  border-radius: 0 0 var(--p-border-radius-200) var(--p-border-radius-200);\n}\n\n.quillEditor :global(.ql-snow .ql-picker.ql-header .ql-picker-label:not([data-value])::before), \n.quillEditor :global(.ql-snow .ql-picker.ql-header .ql-picker-item:not([data-value])::before) {\n  content: 'Paragraph';\n}\n\n.quillEditor :global(.ql-editor){\n  min-height:150px;\n  font-family: var(--p-font-family-sans);\n}\n\n.quillEditor :global(.ql-editor p), \n.quillEditor :global(.ql-editor ol), \n.quillEditor :global(.ql-editor ul), \n.quillEditor :global(.ql-editor pre), \n.quillEditor :global(.ql-editor blockquote), \n.quillEditor :global(.ql-editor h1), \n.quillEditor :global(.ql-editor h2), \n.quillEditor :global(.ql-editor h3), \n.quillEditor :global(.ql-editor h4), \n.quillEditor :global(.ql-editor h5), \n.quillEditor :global(.ql-editor h6) {\n  margin-bottom: 1rem;\n}\n\n.quillEditor :global(.ql-editor ol), \n.quillEditor :global(.ql-editor ul) {\n  padding-left: 0;\n}\n\n.quillEditor :global(.ql-editor ul li) {\n  position: relative;\n  list-style: none;\n}\n  \n.quillEditor :global(.ql-editor ul li::before) {\n  content: '\\2714';\n  margin-left: -1.4em;\n  position: absolute;\n  font-family: Arial, sans-serif;\n}\n\n.quillEditor :global(.ql-editor h1), \n.quillEditor :global(.ql-editor h2), \n.quillEditor :global(.ql-editor h3), \n.quillEditor :global(.ql-editor h4), \n.quillEditor :global(.ql-editor h5), \n.quillEditor :global(.ql-editor h6) {\n  font-weight: bold;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"quillEditor": `quillEditor_quillEditor__rwVQ2`
};
export default ___CSS_LOADER_EXPORT___;
